import {ObjectId} from 'bson';
import {AccountSelection} from '../shared/api/api';
import {useCustomer} from './api/metadata';
import {useNumAccountsToEnrich, useRunEnrichment} from './api/enrichment';
import {useMutation} from '@tanstack/react-query';
import {EnrichmentMode} from '../shared/fields/enrichment';

export const useEnrichAccounts = ({
  accountSelection,
  fieldDefinitionId,
  enrichmentMode,
}: {
  accountSelection: AccountSelection | undefined;
  fieldDefinitionId: ObjectId | undefined;
  enrichmentMode: EnrichmentMode;
}) => {
  const customer = useCustomer();

  const {data: numAccountsToEnrich, isFetching: isNumAccountsToEnrichFetching} =
    useNumAccountsToEnrich(
      !accountSelection || !fieldDefinitionId
        ? 'skipToken'
        : {
            accountSelection,
            fieldDefinitionId,
            enrichmentMode,
          }
    );
  const {mutateAsync, isPending: isRunEnrichmentPending} = useRunEnrichment();

  const {numAccounts, creditsNeeded} = numAccountsToEnrich ?? {};
  const insufficientCredits =
    !!creditsNeeded && creditsNeeded > customer.credits;

  const runEnrichment = useMutation({
    mutationFn: async () => {
      if (!accountSelection || !fieldDefinitionId) {
        return;
      }

      return mutateAsync({
        accountSelection,
        fieldDefinitionId,
        enrichmentMode,
      });
    },
  });

  return {
    numAccountsToEnrich: numAccounts,
    creditsNeeded,
    insufficientCredits,
    isPending: isNumAccountsToEnrichFetching || isRunEnrichmentPending,
    runEnrichment,
  };
};
